/* =========================================================
   Desert City Games — Command Center Panel
   File: assets/dcg-home-panel.js

   IntersectionObserver → .is-visible for entrance stagger.
========================================================= */

(function () {
  'use strict';

  var section = document.querySelector('.dcg-cmd');
  if (!section) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    section.classList.add('is-visible');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          section.classList.add('is-visible');
          observer.unobserve(section);
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(section);
})();
